<template>
  <div class="new-page-con">
    <div class="layout_header">
      <Header> </Header>
    </div>
    <div class="dataServices-page deatService-list-container">
      <div class="deatService-list-inner">
        <div class="deatService-list-header">
          {{page.total}} results found matching<span class="keyword-span">{{ apiName }}</span>
        </div>
        <el-table
          class="dataServiceApiList-table"
          :data="dataServiceApiList"
          style="width: 100%" @row-click="toDetailPage">
          <el-table-column
            prop="name">
            <template slot-scope="scope">
              <div class="dataServiceApiList-title">
                <span class="apiIdStr">{{ scope.row.apiIdStr }}</span>
                <span class="apiName">{{ scope.row.apiName }}</span>
                <div class="api-tag">
                  <el-tag
                    v-for="(i, idx) in scope.row.apiLabels"
                    :key="idx"
                    :class="'COLOR_'+i.labelColor"
                  >
                    {{ i.labelName }}
                  </el-tag>
                </div>
              </div>
              <div class="dataServiceApiList-text">{{ scope.row.apiDataCategoryDescription }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            align="right"
            width="200">
            <template slot-scope="scope">
              <span class="apiPrice">{{ scope.row.apiPrice||'--' }}/call</span>
              <span class="apiFavoriteCount"><img :src="dsListIcon1" alt="">{{scope.row.apiFavoriteCount}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page_i_box dataService" v-if="dataServiceApiList.length>0">
            <Page :totalFont="true" :total="page.total" :pageSize.sync="page.pageSize" :currentPage="page.pageNo" @onPageChange="onPageChangeList"></Page>
            
            <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }} of over {{ page.total | FilterNum }} results</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/views/newLayout/header.vue";
import Header from '../layout/header.vue'
import Page from '@/components/page/index.vue';
import { getApiDataApiPage} from "@/api/dataServicesApi";

export default {
  components: {
    Header,
    Page
  },
  data() {
    return {
      apiName:'',
      dataServiceApiList: [],
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 100
      },
      dsListIcon1: require("@/assets/images/dataServices/dataapi-img/star.svg"),
      
    };
  },
  mounted() {
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    // 从头部搜索框跳转过来的
    if(this.$route.query&&this.$route.query.keyword){
      this.apiName=this.$route.query.keyword
    } 
    this.getApiDataApiPageList()
  },
   watch: {
    // 监听路由变化
    '$route'(to) {
      // 检查 keyword 是否变化
      let newKeyword = to.query.keyword || '';
      if (newKeyword !== this.apiName) {
        this.apiName = newKeyword;
        this.getApiDataApiPageList(); // 重新请求数据
      }
    }
  },
  methods: {
    // 获取二级分类
    getApiDataApiPageList() {
      let params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        categoryId: '',
        apiName:this.apiName,//暂时不用 头部导航里的搜索框的值
        // apiTestStatus:'',//暂时不用 设计图没有状态搜索的设计
        apiUrl: "",
      };
      getApiDataApiPage(params).then((res) => {
        if (res.code == 200) {
          this.dataServiceApiList = JSON.parse(JSON.stringify(res.data.rows));
          console.log("this.dataServiceApiList", this.dataServiceApiList);
          this.page.total = res.data.total;
        }else{
          console.log('res',res.msg);
            this.$message.error(res.msg);
        }
      }).catch(err=>{
        console.log('err',err);
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getApiDataApiPageList();
    },
    // 跳转到详情页
    toDetailPage(row){
      this.$router.push({
           name: "APIHomepage_more_detail",
          query: {
            id: row.id,
            categoryName: row.apiDataCategoryName ,
            successRationStr:row.successRationStr
          },
        });
    }
  },
};
</script>
<style scoped>
/* 引入标签颜色样式 */
@import '../../assets/css/DataLibraryIndexpage.css';

.deatService-list-container{
  padding: 30px;
  overflow-y: auto;
}
.deatService-list-inner{
  padding: 36px;
  background: #FFFFFF;
  border-radius: 4px;
}
.deatService-list-header{
  height: 32px;
  font-weight: 400;
  font-size: 20px;
  color: #1A2332;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 12px;
}
.deatService-list-header .keyword-span{
  display: inline-block;
  background: #B98B73;
  border-radius: 60px 60px 60px 60px;
  padding: 5px 20px;
  color: #FFFFFF;
  margin: 0 12px;
}
.dataServiceApiList-title{
  font-weight: 400;
  font-size: 20px;
  color: #1A2332;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.dataServiceApiList-text{
  font-weight: 400;
  font-size: 20px;
  color: #999999;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.dataServiceApiList-table{
  margin-bottom: 100px;
}
.dataServiceApiList-table /deep/ thead{
  display: none;
}
.dataServiceApiList-table /deep/ td.el-table__cell{
  border-color: #CCCCCC;
}
.dataServiceApiList-table /deep/ .el-table__cell {
  padding: 18px 0;
}
.dataServiceApiList-table /deep/ .cell{
  padding-left: 19px;
}
.dataServiceApiList-table /deep/ tr:hover>td.el-table__cell{
  background: #FAF1EC;
}
.dataServiceApiList-table /deep/ .el-table__row{
  cursor: pointer;
}
.apiIdStr{
  padding:2px 12px;
  display: inline-block;
  background: #F2F3F7;
  border-radius:4px;
  font-size:18px;
  font-weight: bold;
  color:#1A2332;
  margin-right:12px;
  min-width: 60px;
}
.apiName{
  font-size:20px;
  color:#1A2332;
  display: inline-block;
  margin-right:12px;
}
.apiPrice{
  font-size:18px;
  color:#02815C;
  display: inline-block;
  margin-right:38px;
}
.apiFavoriteCount{
  font-size:18px;
  color:#FE9E42;
  display: inline-flex;
  align-items: center; /* 垂直居中 */
  gap: 5px; /* 可选：图标和文字之间的间距 */
}
.apiFavoriteCount img{
  width:18px;
  height:18px;
  vertical-align: middle;
}
/* 标签区域 */
.dataServiceApiList-title .api-tag {
  display: flex;
  gap: 8px;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  .apiIdStr{
    font-size:20px;
  }
  /* 字体 内容改成16px 包括按钮里字体*/
  .el-tag,.dataServiceApiList-text,.search_rsult_txt,.page_txt,.apiPrice,.apiFavoriteCount{
    font-size:16px;
  }
  /* 圆角 改成10px */
  .el-tag{
    border-radius:10px;
  }
  /* padding *0.75 */
  .deatService-list-inner{
    padding:27px;
  }
  /* margin *0.75 */
   /* 表格 表头高度 44px 内容高度50px */
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  .apiIdStr,.deatService-list-header,.apiName{
    font-size:18px;
  }
  /* 字体 内容改成14px 包括按钮里字体*/
  .el-tag,.dataServiceApiList-text,.search_rsult_txt,.page_txt,.apiPrice,.apiFavoriteCount{
    font-size:14px;
  }
  /* 圆角 改成8px */
  .el-tag{
    border-radius:8px;
  }
  /* padding *0.67 */
  .deatService-list-inner{
    padding:20px;
  }
  /* margin *0.67 */
  /* 表格 表头高度 40px 内容高度44px*/
}
</style>
